import { OverallValidationResult, validator } from '../../../tradebuilder-v2/util'
import { EditStrategiesState } from '../edit-strategy-slice'
import { editStrategyRules } from './edit-strategy'

const editStrategyValidator = validator(editStrategyRules)

export function validate(strategyState: EditStrategiesState): OverallValidationResult {
  return editStrategyValidator(strategyState)
}
